export default __webpack_public_path__ + "static/media/placeholder_dummy2016-baeckerei01-mobile-de.4f1ad137.png";